import { http } from "@/lib/http";
import { withIdempotencyKey } from "@/lib/idempotency";
import { isMockEnabled } from "@/lib/mock-flags";
import * as mock from "../mocks/fixtures";
import type { LaunchPartnershipInvite, ReceivedLaunch, RelayResult } from "../mocks/fixtures";

export const listInvites = async (): Promise<LaunchPartnershipInvite[]> => {
  if (isMockEnabled("agency")) return mock.listInvites();
  const { data } = await http.get<LaunchPartnershipInvite[]>("/launches/invites");
  return data;
};

export const listLaunches = async (): Promise<ReceivedLaunch[]> => {
  if (isMockEnabled("agency")) return mock.listLaunches();
  const { data } = await http.get<ReceivedLaunch[]>("/launches");
  return data;
};

export const respondInvite = async (id: string, accept: boolean): Promise<void> => {
  if (isMockEnabled("agency")) return mock.respondInvite();
  const action = accept ? "accept" : "decline";
  await http.post(`/launches/invites/${id}/${action}`, undefined, withIdempotencyKey());
};

export const relayLaunch = async (launchId: string, codes: string[]): Promise<RelayResult> => {
  if (isMockEnabled("agency")) return mock.relayLaunch(codes);
  const { data } = await http.post<RelayResult>(
    `/launches/${launchId}/relay`,
    { codes },
    withIdempotencyKey(),
  );
  return data;
};

export type { LaunchPartnershipInvite, ReceivedLaunch, RelayResult } from "../mocks/fixtures";
